function initProductTabs() {
  const firstTab = document.querySelector('.tablinks');
  if (firstTab) firstTab.click();
}

function openTab(evt, tabName) {
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
}

if (!window.productTabsInitialized) {
  window.productTabsInitialized = true;

  document.addEventListener('DOMContentLoaded', () => {
    const firstTab = document.querySelector('.tablinks');
    if (firstTab) firstTab.click();
  });

  if (typeof subscribe !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html } }) => {
      ['product-specs', 'nutrition-facts'].forEach(panelId => {
        const fullId = `${panelId}-${sectionId}`;
        const source = html.getElementById(fullId);
        const destination = document.getElementById(fullId);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductTabs);
} else {
  initProductTabs();
}